module.exports = __webpack_public_path__ + "static/media/orquestra_salao_2.213d6524.jpg";